import React from "react";
import { serviceLogoUrl } from "../../helpers/ServiceLogo";
import { contactName } from "../../helpers/ContactName";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    formattedPrice,
    getCustomers,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import "../../components/PriceSummary.css";
import "./OfferPreviewScoped.css";
import "./OfferManagement.css";
class OfferAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customers: [],
            loading: false,
            selectedCustomer: [],
            isMobile: false,
            processes: [{ process: "", price: "", kdv: 20, discount: "", unit: "C62", quantity: 1 }],
            formData: {
                customer_id: '',
                description: '',
                kdv: 20,
                is_send: 1,
            },
            showPreview: false,
            previewData: null
        }
    }
    async componentDidMount() {
        try {
            const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
            this.setState({ isMobile });
            this.setState({
                customers: await getCustomers(),
            });
        } catch (e) {
            throw e;
        }
    }
    handleCustomerChange = (selectedCustomer) => {
        const formattedSelectedOptions = {
            value: selectedCustomer.value,
            label: selectedCustomer.label,
        };
        this.setState((prevState) => ({

            formData: {
                ...prevState.formData,
                customer_id: formattedSelectedOptions.value
            },
            selectedCustomer: formattedSelectedOptions
        }));

    };
    handleChange = (e) => {
        const { id, name, value, type, checked } = e.target;
        const key = name || id;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [key]: type === 'radio' ? (checked ? parseInt(value) : 0) : value
            }
        }));
    }
    handleAddProcess = () => {
        this.setState((prevState) => ({
            processes: [...prevState.processes, { process: "", price: "", kdv: 20, discount: "", unit: "C62", quantity: 1 }],
        }));
    };

    handleRemoveProcess = (index) => {
        this.setState((prevState) => ({
            processes: prevState.processes.filter((_, i) => i !== index),
        }));
    };
    calculateTotals = () => {
        const { processes } = this.state;
        let totalPrice = 0;
        let totalWithKdv = 0;
        let totalKdv = 0;
        let totalDiscount = 0;
        let discount = 0;

        processes.forEach((process) => {
            const quantity = parseFloat(process.quantity ?? 1) || 0;
            const price = parseFloat(process.price) || 0;
            const kdvRate = parseFloat(process.kdv) || 0;
            const discountRate = parseFloat(process.discount) || 0;
            discount = (price * quantity * discountRate) / 100;
            totalPrice += price * quantity;
            totalDiscount += discount;

            const discountedPrice = (price * quantity) - discount;
            const kdvAmount = (discountedPrice * kdvRate) / 100;

            totalKdv += kdvAmount;
            totalWithKdv += discountedPrice + kdvAmount;
        });

        totalPrice = totalPrice.toFixed(2);
        totalWithKdv = totalWithKdv.toFixed(2);
        totalKdv = totalKdv.toFixed(2);
        totalDiscount = totalDiscount.toFixed(2);

        return { totalPrice, totalWithKdv, totalKdv, totalDiscount };
    };

    handleProcessChange = (index, field, value) => {
        this.setState((prevState) => {
            const updatedProcesses = prevState.processes.map((process, i) =>
                i === index ? { ...process, [field]: value } : process
            );
            return { processes: updatedProcesses };
        });
    };

    // Preview verisini hazırlayan yardımcı fonksiyon
    preparePreviewData = () => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const { formData, processes, customers } = this.state;

        // Müşteri bilgilerini bul
        const customer = customers.find(c => String(c.id) === String(formData.customer_id)) || {};

        // Servis bilgilerini al
        const serviceData = userData.service || userData;

        // Logo URL'ini storage type'a göre oluştur
        const logoUrl = serviceLogoUrl(serviceData);

        // Preview verisini hazırla
        return {
            customer: {
                name: customer.name || '',
                surname: customer.surname || '',
                phone: customer.phone || '',
                email: customer.email || '',
                address: customer.address || ''
            },
            service: {
                name: serviceData.name || '',
                phone: serviceData.phone || '',
                email: serviceData.email || '',
                address: serviceData.address || '',
                logo: serviceData.logo || '',
                logo_storage_type: serviceData.logo_storage_type || 'local',
                logo_url: logoUrl
            },
            description: formData.description || '',
            processes: processes
        };
    };

    // Component güncellendiğinde önizlemeyi otomatik güncelle
    componentDidUpdate(prevProps, prevState) {
        // Önizleme açıkken ve veriler değiştiğinde previewData'yı güncelle
        if (this.state.showPreview) {
            const hasDataChanged =
                prevState.formData.customer_id !== this.state.formData.customer_id ||
                prevState.formData.description !== this.state.formData.description ||
                JSON.stringify(prevState.processes) !== JSON.stringify(this.state.processes);

            if (hasDataChanged) {
                const previewData = this.preparePreviewData();
                this.setState({ previewData });
            }
        }
    }

    offerPreview = () => {
        const previewData = this.preparePreviewData();

        // Önizlemeyi göster ve sayfayı aşağı kaydır
        this.setState({ showPreview: true, previewData }, () => {
            // Önizleme bölümüne scroll yap
            setTimeout(() => {
                const previewElement = document.getElementById('offer-preview-section');
                if (previewElement) {
                    previewElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        });
    };
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData, processes } = this.state;
        const offerFormData = new FormData();
        Object.keys(formData).forEach(key => {
            offerFormData.append(key, formData[key]);
        });
        offerFormData.append('process', JSON.stringify(processes));
        try {
            const response = await apiCall('business/offers/add', 'post', offerFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });

        }
    }
    render() {
        const { totalPrice, totalKdv, totalWithKdv, totalDiscount } = this.calculateTotals();
        const { loading, customers, isMobile, selectedCustomer } = this.state;
        const { userPermissions } = this.props;
        const userHasAddOfferPermission = userPermissions.includes('new offer');
        const customerFormattedOptions = customers && customers.map(option => ({
            value: option.id,
            label: contactName(option)
        }));
        return (
            <div
                className="offer-page offer-form-page"
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Teklif Ekle"
                            Breadcrumb={[
                                { name: "Teklifler", navigate: "offers" },
                                { name: "Yeni Teklif", navigate: "" },
                            ]}
                        />
                        <section className="offer-hero offer-form-hero">
                            <div className="offer-hero-copy">
                                <span className="offer-eyebrow"><i className="fa fa-circle" /> YENİ TEKLİF</span>
                                <h1>Müşterinize özel teklif hazırlayın</h1>
                                <p>Müşteri ve ürün/hizmet bilgilerini ekleyin, tutarları anlık kontrol edin ve göndermeden önce önizleyin.</p>
                            </div>
                            <Link className="offer-hero-action secondary" to="/offers">
                                <i className="fa fa-arrow-left" /> Tekliflere dön
                            </Link>
                        </section>
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card offer-form-card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body offer-form-intro">
                                            <h5 className="mb-3">
                                                <i className="fa fa-file-text-o mr-2 text-cyan"></i>
                                                Teklif Bilgileri
                                            </h5>
                                            <div className="alert alert-info mb-4" style={{ borderLeft: '4px solid #17a2b8' }}>
                                                <i className="fa fa-info-circle mr-2"></i>
                                                <small>ServiceZone ile teklif oluşturma özelliğini kullanarak
                                                    müşterinize sunmadan önce, önizleme butonuyla teklifinizi
                                                    gözden geçirebilir, hataları fark edip profesyonel bir sunum
                                                    yapabilirsiniz.</small>
                                            </div>
                                        </div>
                                        <div className="body offer-form-section offer-customer-section">
                                            <div className="row clearfix">
                                                <div className="col-lg-4 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="customer_id" className="font-weight-bold">
                                                            <i className="fa fa-user mr-2 text-cyan"></i>
                                                            Müşteri
                                                        </label>
                                                        <Select
                                                            id="customer"
                                                            placeholder="Müşteri Seçiniz..."
                                                            options={customerFormattedOptions}
                                                            value={selectedCustomer}
                                                            onChange={this.handleCustomerChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="font-weight-bold">
                                                            <i className="fa fa-sticky-note mr-2 text-cyan"></i>
                                                            Açıklama
                                                        </label>
                                                        <textarea
                                                            id="description"
                                                            className="form-control"
                                                            placeholder="Teklif açıklaması..."
                                                            rows="3"
                                                            onChange={this.handleChange}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="status" className="font-weight-bold d-block mb-3">
                                                            <i className="fa fa-clock-o mr-2 text-cyan"></i>
                                                            Gönderim Zamanı
                                                        </label>
                                                        <div>
                                                            <label className="fancy-radio">
                                                                <input
                                                                    name="is_send"
                                                                    id="now"
                                                                    type="radio"
                                                                    value="1"
                                                                    checked={this.state.formData.is_send === 1}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <span><i></i>Hemen Gönder</span>
                                                            </label>
                                                            <label className="fancy-radio">
                                                                <input
                                                                    name="is_send"
                                                                    id="later"
                                                                    type="radio"
                                                                    value="0"
                                                                    checked={this.state.formData.is_send === 0}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <span><i></i>Sonra Gönder</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="body offer-form-section offer-items-section">
                                            <h5 className="mb-4">
                                                <i className="fa fa-list mr-2 text-cyan"></i>
                                                Ürün/Hizmet Detayları
                                            </h5>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    {this.state.processes.map((process, index) => (
                                                        <div key={index} className="form-row align-items-end mb-3 offer-line-item">

                                                            <div className="col-lg">
                                                                <label htmlFor={`process`} className="font-weight-bold small">
                                                                    Ürün/Hizmet
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id={`process`}
                                                                    placeholder="Ürün/Hizmet adı..."
                                                                    value={process.process}
                                                                    onChange={(e) => this.handleProcessChange(index, "process", e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg">
                                                                <label htmlFor={`unit`} className="font-weight-bold small">Birim</label>
                                                                <select
                                                                    id={`unit`}
                                                                    className="form-control"
                                                                    value={process.unit}
                                                                    onChange={(e) => this.handleProcessChange(index, "unit", e.target.value)}
                                                                >
                                                                    <option value="">Seçiniz</option>
                                                                    <option value="C62">Adet</option>
                                                                    <option value="KGM">Kg</option>
                                                                    <option value="LTR">Litre</option>
                                                                    <option value="MTK">Metre Kare</option>
                                                                    <option value="MTQ">Metre Küp</option>
                                                                    <option value="PR">Çift</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-lg">
                                                                <label htmlFor={`quantity`} className="font-weight-bold small">Miktar</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id={`quantity`}
                                                                    placeholder="0"
                                                                    value={process.quantity}
                                                                    onChange={(e) => this.handleProcessChange(index, "quantity", e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-lg">
                                                                <label htmlFor={`kdv`} className="font-weight-bold small">KDV (%)</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id={`kdv`}
                                                                    placeholder="20"
                                                                    value={process.kdv}
                                                                    onChange={(e) => this.handleProcessChange(index, "kdv", e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-lg">
                                                                <label htmlFor={`discount`} className="font-weight-bold small">İndirim (%)</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id={`discount`}
                                                                    placeholder="0"
                                                                    value={process.discount}
                                                                    onChange={(e) => this.handleProcessChange(index, "discount", e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg">
                                                                <label htmlFor={`price`} className="font-weight-bold small">
                                                                    Tutar (₺)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id={`price`}
                                                                    placeholder="0.00"
                                                                    value={process.price}
                                                                    onChange={(e) => this.handleProcessChange(index, "price", e.target.value)}
                                                                />
                                                            </div>

                                                            <div className={isMobile ? 'col-lg mt-2' : 'col-auto'}>
                                                                {index > 0 ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger w-100"
                                                                        onClick={() => this.handleRemoveProcess(index)}
                                                                        title="Satırı Sil"
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-success w-100"
                                                                        onClick={this.handleAddProcess}
                                                                        title="Yeni Satır Ekle"
                                                                    >
                                                                        <i className="fa fa-plus"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="price-summary-wrapper">
                                            <div className="price-summary-container">
                                                {/* Header */}
                                                <div className="price-summary-header">
                                                    <h6>
                                                        <i className="fa fa-calculator mr-2"></i>
                                                        Fiyat Özeti
                                                    </h6>
                                                </div>

                                                {/* Price Grid */}
                                                <div style={{ display: 'block', width: '100%' }}>
                                                    {/* İlk 3 Element - Tek Satırda */}
                                                    <div className="offer-price-grid">
                                                        {/* Toplam Tutar */}
                                                        <div className="price-summary-item total-item">
                                                            <i className="fa fa-money price-summary-icon"></i>
                                                            <small className="price-summary-label">Toplam Tutar</small>
                                                            <p className="price-summary-value">{formattedPrice(totalPrice)}</p>
                                                        </div>

                                                        {/* KDV Tutarı */}
                                                        <div className="price-summary-item tax-item">
                                                            <i className="fa fa-percent price-summary-icon"></i>
                                                            <small className="price-summary-label">KDV Tutarı</small>
                                                            <p className="price-summary-value">{formattedPrice(totalKdv)}</p>
                                                        </div>

                                                        {/* Toplam İndirim */}
                                                        <div className="price-summary-item discount-item">
                                                            <i className="fa fa-tag price-summary-icon"></i>
                                                            <small className="price-summary-label">Toplam İndirim</small>
                                                            <p className="price-summary-value">{formattedPrice(totalDiscount)}</p>
                                                        </div>
                                                    </div>

                                                    {/* KDV Dahil Tutar (Final) / Ayrı ve Tam genişlikte */}
                                                    <div className="price-summary-item final-item">
                                                        <i className="fa fa-check-circle price-summary-icon"></i>
                                                        <small className="price-summary-label">KDV Dahil Toplam Tutar</small>
                                                        <p className="price-summary-value">{formattedPrice(totalWithKdv)}</p>
                                                    </div>
                                                </div>

                                                {/* Kaydet ve Önizle Butonları - KDV Dahil Toplam Tutar Altında */}
                                                <div className="offer-form-actions">
                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-lg" disabled={true}
                                                            style={{ flex: 1, textAlign: "center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2" style={{ display: 'inline-block', marginLeft: '10px' }}></ReactLoading>
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button
                                                                disabled={!userHasAddOfferPermission}
                                                                className="btn btn-outline-primary"
                                                                type="submit"
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '0.75rem 1.5rem',
                                                                    fontSize: '0.95rem',
                                                                    fontWeight: '500',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '0.5rem'
                                                                }}>
                                                                <i className="fa fa-save"></i>
                                                                Kaydet
                                                            </button>
                                                            <button
                                                                onClick={this.offerPreview}
                                                                className="btn btn-outline-success"
                                                                type="button"
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '0.75rem 1.5rem',
                                                                    fontSize: '0.95rem',
                                                                    fontWeight: '500',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '0.5rem'
                                                                }}>
                                                                <i className="fa fa-eye"></i>
                                                                Önizleme
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                {/* Önizleme Bölümü */}
                                {this.state.showPreview && this.state.previewData && this.renderPreview()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handlePrintOffer = async () => {
        const element = document.getElementById('offer-preview-content');
        if (!element) {
            console.error('Preview content not found');
            return;
        }

        // Geçici olarak butonları gizle
        const printButtons = document.querySelector('.no-print');
        if (printButtons) printButtons.style.display = 'none';

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                windowWidth: element.scrollWidth,
                windowHeight: element.scrollHeight
            });

            const imgData = canvas.toDataURL('image/jpeg', 0.95);
            const pdf = new jsPDF('p', 'mm', 'a4');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 10;

            pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);

            // Print için yeni pencere aç
            const pdfBlob = pdf.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            const printWindow = window.open(pdfUrl, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    printWindow.print();
                };
            }

            // 1 saniye sonra URL'i temizle
            setTimeout(() => {
                URL.revokeObjectURL(pdfUrl);
            }, 1000);
        } catch (err) {
            console.error('Print error:', err);
            alert('Yazdırma sırasında bir hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            if (printButtons) printButtons.style.display = 'flex';
        }
    };

    handleDownloadPDF = async () => {
        const element = document.getElementById('offer-preview-content');
        if (!element) {
            console.error('Preview content not found');
            return;
        }

        // Geçici olarak butonları gizle
        const printButtons = document.querySelector('.no-print');
        if (printButtons) printButtons.style.display = 'none';

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                windowWidth: element.scrollWidth,
                windowHeight: element.scrollHeight
            });

            const imgData = canvas.toDataURL('image/jpeg', 0.95);
            const pdf = new jsPDF('p', 'mm', 'a4');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 10;

            pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
            pdf.save(`Teklif_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.pdf`);
        } catch (err) {
            console.error('PDF generation error:', err);
        } finally {
            if (printButtons) printButtons.style.display = 'flex';
        }
    };

    renderPreview = () => {
        const { previewData } = this.state;
        const { customer, service, description, processes } = previewData;

        // Hesaplamalar
        let total = 0;
        let totalKdv = 0;
        let totalDiscount = 0;
        let discountedTotal = 0;

        processes.forEach((item) => {
            const quantity = parseFloat(item.quantity ?? 1) || 0;
            const price = parseFloat(item.price) || 0;
            const kdvRate = parseFloat(item.kdv) || 0;
            const discountRate = parseFloat(item.discount) || 0;

            const itemTotal = price * quantity;
            const discount = (itemTotal * discountRate) / 100;
            const discountedPrice = itemTotal - discount;
            const kdvAmount = (discountedPrice * kdvRate) / 100;

            total += itemTotal;
            totalDiscount += discount;
            discountedTotal += discountedPrice;
            totalKdv += kdvAmount;
        });

        const finalTotal = discountedTotal + totalKdv;
        const currentDate = new Date().toLocaleString('tr-TR');

        return (
            <div id="offer-preview-section" className="col-lg-12 mt-4">
                <div className="card">
                    <div className="card-header" style={{ background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)', color: 'white' }}>
                        <h5 className="mb-0">
                            <i className="fa fa-eye mr-2"></i>
                            Teklif Önizlemesi
                        </h5>
                        <button
                            onClick={() => this.setState({ showPreview: false })}
                            className="btn btn-sm btn-light float-right"
                            style={{ marginTop: '-30px' }}
                        >
                            <i className="fa fa-times"></i> Kapat
                        </button>
                    </div>
                    <div className="card-body p-0">
                        <div id="offer-preview-content" className="offer-preview-scoped">
                            {/* Servis Logosu - En Üstte Ortalı */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '2rem 0 1rem 0',
                                borderBottom: '1px solid #e8eaed'
                            }}>
                                {service.logo_url ? (
                                    <img
                                        crossOrigin="anonymous"
                                        src={service.logo_url}
                                        alt={service.name}
                                        style={{
                                            maxWidth: '400px',
                                            maxHeight: '200px',
                                            objectFit: 'contain'
                                        }}
                                        onError={(e) => {
                                            // Hata durumunda servis adını göster
                                            e.target.style.display = 'none';
                                            const fallbackDiv = document.createElement('div');
                                            fallbackDiv.style.fontSize = '1.5rem';
                                            fallbackDiv.style.fontWeight = 'bold';
                                            fallbackDiv.style.color = '#17a2b8';
                                            fallbackDiv.textContent = service.name || 'Servis Adı';
                                            e.target.parentElement.appendChild(fallbackDiv);
                                        }}
                                    />
                                ) : (
                                    <div style={{
                                        fontSize: '1.5rem',
                                        fontWeight: 'bold',
                                        color: '#17a2b8'
                                    }}>
                                        {service.name || 'Servis Adı'}
                                    </div>
                                )}
                            </div>

                            <div className="cs-container" style={{ maxWidth: '95%', margin: '0 auto' }}>
                                <div className="cs-invoice cs-style1">
                                    <div className="cs-invoice_in">

                                        {/* Header */}
                                        <div className="cs-invoice_head cs-type1 cs-mb25">
                                            <div className="cs-invoice_left">
                                                <p className="cs-invoice_date cs-primary_color cs-m0">
                                                    <b className="cs-primary_color">Tarih: </b>{currentDate}
                                                </p>
                                            </div>
                                            <div className="cs-invoice_center">
                                                <p className="cs-invoice_date cs-primary_color cs-m0">
                                                    <b className="cs-primary_color">Teklif Formu</b>
                                                </p>
                                            </div>
                                            <div className="cs-invoice_right" aria-hidden="true" />
                                        </div>

                                        {/* Service and Customer Info */}
                                        <div className="cs-invoice_head cs-mb10">
                                            <div className="cs-invoice_left">
                                                <b className="cs-primary_color">Servis:</b>
                                                <p>
                                                    {service.name?.toUpperCase() || ''}<br />
                                                    {service.phone || ''}<br />
                                                    {service.email || ''}<br />
                                                    {service.address?.toUpperCase() || ''}
                                                </p>
                                            </div>
                                            <div className="cs-invoice_right cs-text_right">
                                                <b className="cs-primary_color">Müşteri</b>
                                                <p>
                                                    {customer.name?.toUpperCase() || ''} {customer.surname?.toUpperCase() || ''}<br />
                                                    {customer.phone || ''}<br />
                                                    {customer.email || ''}<br />
                                                    {customer.address?.toUpperCase() || ''}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Description */}
                                        {description && (
                                            <div className="cs-table cs-style1" style={{ marginTop: '15px' }}>
                                                <div className="cs-round_border">
                                                    <div className="cs-table_responsive">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th className="cs-width_6 cs-semi_bold cs-primary_color cs-focus_bg">
                                                                        Detay
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="cs-width_6">{description}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Processes Table */}
                                        <div className="cs-table cs-style1" style={{ marginTop: '15px' }}>
                                            <div className="cs-round_border">
                                                <div className="cs-table_responsive">
                                                    <table style={{ tableLayout: 'fixed', width: '100%' }}>
                                                        <thead>
                                                            <tr>
                                                                <th className="cs-semi_bold cs-primary_color cs-focus_bg" style={{ width: '40%' }}>
                                                                    Yapılan İşlem
                                                                </th>
                                                                <th className="cs-semi_bold cs-primary_color cs-focus_bg" style={{ width: '15%' }}>
                                                                    Fiyat
                                                                </th>
                                                                <th className="cs-semi_bold cs-primary_color cs-focus_bg" style={{ width: '15%' }}>
                                                                    KDV
                                                                </th>
                                                                <th className="cs-semi_bold cs-primary_color cs-focus_bg" style={{ width: '15%' }}>
                                                                    İndirim
                                                                </th>
                                                                <th className="cs-semi_bold cs-primary_color cs-focus_bg" style={{ width: '15%' }}>
                                                                    İndirimli Fiyat
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {processes.map((item, index) => {
                                                                const quantity = parseFloat(item.quantity ?? 1) || 0;
                                                                const price = parseFloat(item.price) || 0;
                                                                const itemTotal = price * quantity;
                                                                const discount = item.discount ? (itemTotal * (item.discount / 100)) : 0;
                                                                const discountedPrice = itemTotal - discount;
                                                                const kdv = (discountedPrice * (item.kdv / 100));

                                                                return (
                                                                    <tr key={index}>
                                                                        <td style={{
                                                                            wordWrap: 'break-word',
                                                                            whiteSpace: 'normal',
                                                                            padding: '8px'
                                                                        }}>
                                                                            {item.process?.toUpperCase() || '-'}
                                                                        </td>
                                                                        <td style={{ padding: '8px' }}>{itemTotal.toFixed(2)}₺</td>
                                                                        <td style={{ padding: '8px' }}>{kdv.toFixed(2)}₺</td>
                                                                        <td style={{ padding: '8px' }}>{item.discount ? item.discount + '%' : '0%'}</td>
                                                                        <td style={{ padding: '8px' }}>{discountedPrice.toFixed(2)}₺</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Footer Totals */}
                                                <div className="cs-invoice_footer cs-border_top">
                                                    <div className="cs-left_footer cs-mobile_hide">
                                                        <p className="cs-mb0"><b className="cs-primary_color">Bilgilendirme:</b></p>
                                                        <p className="cs-m0">
                                                            Bu formdaki içerikler ve fiyatlar, servisin <br />
                                                            gereksinimlerine ve müşteri tercihlerine göre değişebilir.
                                                        </p>
                                                    </div>
                                                    <div className="cs-right_footer">
                                                        <table>
                                                            <tbody>
                                                                <tr className="cs-border_left">
                                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                                        Ara Toplam
                                                                    </td>
                                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                                        {formattedPrice(total.toFixed(2))}
                                                                    </td>
                                                                </tr>
                                                                <tr className="cs-border_left">
                                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                                        İndirimli Ara Toplam
                                                                    </td>
                                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                                        {formattedPrice(discountedTotal.toFixed(2))}
                                                                    </td>
                                                                </tr>
                                                                <tr className="cs-border_left">
                                                                    <td className="cs-width_3 cs-semi_bold cs-primary_color cs-focus_bg">
                                                                        Toplam KDV
                                                                    </td>
                                                                    <td className="cs-width_3 cs-semi_bold cs-focus_bg cs-primary_color cs-text_right">
                                                                        {formattedPrice(totalKdv.toFixed(2))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="cs-invoice_footer">
                                                    <div className="cs-left_footer cs-mobile_hide"></div>
                                                    <div className="cs-right_footer">
                                                        <table>
                                                            <tbody>
                                                                <tr className="cs-border_none">
                                                                    <td className="cs-width_3 cs-border_top_0 cs-bold cs-f16 cs-primary_color">
                                                                        Ödenecek Tutar
                                                                    </td>
                                                                    <td className="cs-width_3 cs-border_top_0 cs-bold cs-f16 cs-primary_color cs-text_right">
                                                                        {formattedPrice(finalTotal.toFixed(2))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Note */}
                                        <div className="cs-note">
                                            <div className="cs-note_left">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                                                    <path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="32" />
                                                    <path d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                                </svg>
                                            </div>
                                            <div className="cs-note_right">
                                                <p className="cs-mb0"><b className="cs-primary_color cs-bold">Not:</b></p>
                                                <p className="cs-m0">Bu rapor bilgisayar tarafından üretilmiştir ve fiziksel imza gerektirmez.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> {/* End of offer-preview-content */}

                        {/* Yazdır ve PDF İndir Butonları */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '1rem',
                            padding: '2rem',
                            borderTop: '1px solid #e8eaed',
                            background: '#fafbfc'
                        }} className="no-print">
                            <button
                                onClick={this.handlePrintOffer}
                                className="btn btn-outline-primary"
                                style={{
                                    minWidth: '150px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    padding: '0.75rem 1.5rem',
                                    fontSize: '0.95rem',
                                    fontWeight: '500'
                                }}
                            >
                                <i className="fa fa-print"></i>
                                Yazdır
                            </button>
                            <button
                                onClick={this.handleDownloadPDF}
                                className="btn btn-outline-success"
                                style={{
                                    minWidth: '150px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    padding: '0.75rem 1.5rem',
                                    fontSize: '0.95rem',
                                    fontWeight: '500'
                                }}
                            >
                                <i className="fa fa-file-pdf-o"></i>
                                PDF İndir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(OfferAdd)));
